import { render, staticRenderFns } from "./SubmittedEmdRejected.vue?vue&type=template&id=5449ce2a&scoped=true&"
import script from "./SubmittedEmdRejected.vue?vue&type=script&lang=js&"
export * from "./SubmittedEmdRejected.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5449ce2a",
  null
  
)

export default component.exports